import { FormSliderInputComponent } from 'src/features/generalForms/builder/types/SliderInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormSliderInput: FormSliderInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return (
    <AnswerPreviewRow<number>
      value={value}
      isOptional={props.isOptional}
      renderValue={(v) => v.toString()}
      {...props}
    />
  );
};
